import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Store
import { actionOverlay } from '../../store/Overlay';

// Components
import { Screen } from '../Layout/Screen';
import Close from '../CloseBtn';
import LineLink from '../LineLink';
import { ContentContainer } from '../Layout/ContentContainer';

// Assets
import { brandColors, device, fixPoints } from '../../styles/variables';
import circleClose from '../../assets/images/circle-close.png';
import office from '../../assets/images/RD_Team_image_1_blue.jpg';

const BackgroundOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: url(${office}) no-repeat;
  background-size: cover;
  background-position: center;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  z-index: 5;
`;

const StyledScreen = Screen.extend`
  width: 100%;
  height: auto;
  background: ${brandColors.blue};

  @media ${device.tablet} {
    min-height: 100% !important;
  }
`;

const ContentHolder = styled.div`
  width: 100%;
  position: relative;
  z-index: 6;
  padding: 0 30px;
`;

const CaseStudiesClose = styled(Close)`
  position: relative;
  height: 49px;
  width: 49px;
`;

const mediaQuery = `${device.laptop} and ${fixPoints.oneMax}`;
const Content = ContentContainer.extend`
  height: auto;
  padding: 90px 0 0 0;
  @media ${device.laptop} {
    padding: 140px 0 0 0;
  }
  @media ${mediaQuery} {
    padding: 140px 0 0 0;
  }
`;

const Menu = styled.div`
  padding: 46px 0 0 0;

  @media ${device.tablet} {
    padding: 0;
    position: absolute;
    left: 50%;
    top: 154px;
  }
  @media ${device.laptop} {
    top: 203px;
  }
`;

class CaseStudiesOverlay extends React.PureComponent {
  animation() {}

  render() {
    const { overlay, closeOverlay } = this.props;

    return (
      <StyledScreen>
        <BackgroundOverlay />
        <ContentHolder>
          <Content>
            <CaseStudiesClose
              src={circleClose}
              alt="Close overlay"
              onClick={() => closeOverlay({ opened: false, overlayType: overlay.overlayType })}
              overlayType={overlay.overlayType}
            />
            <LineLink className="title" linkText="best of projects" subtitle="see our work" />
            <Menu>
              <LineLink
                linkText="making of an industry leader"
                linkColor={brandColors.lightblue}
                route="/making-of-an-industry-leader"
                listV
                lineBreak
                active
              />
              <LineLink
                linkText="a new hope in dermatology"
                linkColor={brandColors.yellow}
                route="/advocating-for-patients-hope"
                listV
                lineBreak
                active
              />
              <LineLink
                linkText="bridging the gap"
                linkColor={brandColors.orange}
                route="/bridging-the-gap"
                listV
                lineBreak
                active
              />
            </Menu>
          </Content>
        </ContentHolder>
      </StyledScreen>
    );
  }
}

CaseStudiesOverlay.defaultProps = {
  overlay: {}
};

CaseStudiesOverlay.propTypes = {
  overlay: PropTypes.object,
  closeOverlay: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  overlay: state.overlay
});

const mapDispatchToProps = dispatch => ({
  closeOverlay(overlayState) {
    dispatch(actionOverlay(overlayState));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseStudiesOverlay);



// WEBPACK FOOTER //
// ./src/components/Overlay/CaseStudiesOverlay.jsx